import ArticleCategoryInterface from "@app/Interface/ArticleCategoryInterface";
import ArticleInterface from "@app/Interface/ArticleInterface";
import EmbeddedFileInterface from "@app/Interface/EmbeddedFileInterface";

export default class ArticleModel implements ArticleInterface {
    public id: number;
    public slug: string;
    public title: string;
    public excerpt: string;
    public date: Date;
    public body: string;
    public categories: ArticleCategoryInterface[];
    public featuredImage: EmbeddedFileInterface | string | null;

    constructor() {
        this.id = 0;
        this.slug = "";
        this.title = "";
        this.excerpt = "";
        this.date = new Date();
        this.body = "";
        this.categories = [];
        this.featuredImage = "";
    }

}